import { capitalizeFilter } from '@/filters/capitalize.filter'
import { dateFilter } from '@/filters/date.filter'
import { uppercaseFilter } from '@/filters/uppercase.filter'
import { currencyFilter } from '@/filters/currency.filter'
import { VueConstructor } from 'vue/types/vue'
import { gapFilter } from '@/filters/gap.filter'

export default function registerGlobalFilters(Vue: VueConstructor) {
  const filters: any = {
    // Declare filters here
    capitalize: capitalizeFilter,
    date: dateFilter,
    uppercase: uppercaseFilter,
    currency: currencyFilter,
    gap: gapFilter,
  }

  Object.keys(filters).forEach((name: string) => {
    Vue.filter(name, filters[name])
  })
}
